<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-08 18:39:46
 * @LastEditTime: 2022-03-01 19:41:08
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
      <div class="dialog__box" v-if="product">
        <div class="dialog__title">
          <span class="line--bar"></span><span>考级通知</span><span class="line--bar"></span>
        </div>
        <div class="dialog__info">
          <div class="row first">
            <p>{{product.productName}}</p>
            <p>
              <span></span>{{checkTypeMapping(product.checkType)}}
            </p>
          </div>
          <div class="row second">

            <p v-if="isFree"><span>免费</span></p>
            <p v-else>￥ <span>{{product.examFee}}</span> 元</p>
            <p v-if="product.effectiveDays != 0">资格有效天数 <span>{{product.effectiveDays}}</span> 天</p>
          </div>
          <div class="row third">
            {{product.productDescription}}
          </div>
        </div>
        <div class="dialog__options">
          <div class="apply--button--list">
            <div class="apply--button" :class="{disabled: !product.showStatus}" @click="apply">申请</div>
            <div v-if="!isFree" class="apply--button" :style="{background: 'linear-gradient(360deg, #763B03 0%, #C65F01 100%)'}" @click="handleUseActivateCode">使用激活卡</div>
          </div>
          <div class="apply--date" v-if="product.availableTime">{{product.availableTime}} 可申请</div>
          <div class="close" @click="close">
            <img src="@/render/assets/images/home/close_grading_notice.png">
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import dialogMixin from './mixin'
import { homeAPI } from '@/apis'
export default {
  mixins: [dialogMixin],
  props: {
    product: {
      type: Object
    },
  },
  computed: {
    isFree() {
      return Number(this.product.examFee) === 0
    }
  },
  methods: {
    async handleApplyFreeProduct(product) {
      return await homeAPI.postApplyFreeProduct({
        productUid: product.uid,
      })
    },
    checkTypeMapping(checkType) {
      return {
        1: '自动审批',
        2: '人工审批'
      }[checkType]
    },
    async apply() {
      if (!this.product.showStatus) return;

      if (this.isFree) {
        try {
          await this.handleApplyFreeProduct(this.product)
          this.$emit("success")
        } catch (error) {
          throw error
        }
      } else {
        if (this.product.checkType === 1) {
          this.$router.push(`/personal-agreement?checkType=${this.product.checkType}&productUid=${this.product.uid}`)
        } else {
          this.$router.push(`/personal-activity?checkType=${this.product.checkType}&productUid=${this.product.uid}`)
        }
      }
    },
    handleUseActivateCode() {
      this.$emit('useActivateCode', this.product)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./dialog.scss";
.dialog {
  &__box {
    padding: val(24) 0 val(46);
    width: val(500);
    height: val(280);
    background: url('../../assets/images/home/grading_notice_bg.png') no-repeat left top;
    background-size: 100%;
  }
  &__title {
    margin-bottom: val(46);
    text-align: center;
    font-size: val(24);
    line-height: val(24);
    color: #B16012;
    display: flex;
    justify-content: center;
    align-items: center;
    .line--bar{
      margin: 0 val(10);
      width: val(20);
      height: val(1);
      background: url(../../assets/images/home/line_bar.png) left top no-repeat;
      background-size: 100%;
      &:first-of-type {
        transform: rotate(180deg);
      }
    }
  }
  &__info .row{
    &.first {
      display: flex;
      justify-content: space-between;
      padding: 0 val(50);
      margin-bottom: val(7);
      p {
        &:first-of-type {
          line-height: val(24);
          font-size: val(24);
          font-weight: bold;
          color: #502700;
        }
        &:last-of-type {
          display: flex;
          align-items: center;
          line-height: val(16);
          font-size: val(16);
          color: #502700;
          span {
            margin-right: val(6);
            width: val(15);
            height: val(16);
            background: url(../../assets/images/home/icon_audit.png) left top no-repeat;
            background-size: 100%;
          }
        }
      }
    }
    &.second {
      margin-bottom: val(30);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 val(50);
      p {
        &:first-of-type {
          line-height: val(21);
          font-size: val(16);
          color: #502700;
          span {
            color: #FF7700;
          }
        }
        &:last-of-type {
          line-height: val(21);
          font-size: val(14);
          color: #502700;
          span {
            color: #FF7C00;
          }
        }
      }
    }
    &.third {
      padding: 0 val(42);
      line-height: val(32);
      height: val(42);
      overflow: auto;
      font-size: val(16);
      color: #502700;
    }
  }
  &__options {
    position: absolute;
    bottom: val(28);
    left: 0;
    right: 0;
    transform: translateY(100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .apply--button--list {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .apply--button {
      cursor: pointer;
      margin-bottom: val(7);
      width: val(218);
      line-height: val(56);
      text-align: center;
      border-radius: val(37);
      background: linear-gradient(360deg, #B26113 0%, #FDAE5F 100%);
      font-size: val(24);
      color: #FFFFFF;
      text-shadow: 3.773547887802124px 3.2802951335906982px 9px rgba(178, 94, 12, 0.3);
      &.disabled {
        color: #6A6A6A;
        background: linear-gradient(360deg, #8D8D8D 0%, #C1C1C1 56%, #E9E9E9 100%);
        text-shadow: unset;
      }
    }
    .apply--date {
      margin-bottom: val(19);
      line-height: val(21);
      font-size: val(16);
      color: #FFC45E;
      text-align: center;
    }
    .close {
      cursor: pointer;
      width: val(42);
    }


  }
}
</style>
